export default __webpack_public_path__ + "static/media/img_history_2.47625efc.jpg";